import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';
import { CultureTextModel } from '../form';

export interface StaticTextFieldModel extends BaseFieldModel {
  value: CultureTextModel[] | string;
  defaultValue: string | undefined;
  type: FieldType.StaticText;
}
export class StaticTextField extends BaseField implements StaticTextFieldModel {
  public value: CultureTextModel[] | string = '';
  public defaultValue: string | undefined;
  public type: FieldType.StaticText = FieldType.StaticText;

  constructor(cultures: string[]) {
    super(FieldType.StaticText, cultures);

    this.value = [];

    for (const culture of cultures) {
      this.value.push({ culture, value: '' });
    }
  }
}
